import React, { useState } from 'react';

interface SelectStatsProps {
  stats?: number;
  onSelectStats?: (value: number | undefined) => void;
}

const SelectStats: React.FC<SelectStatsProps> = ({ stats, onSelectStats }) => {
  const [checkedIndex, setCheckedIndex] = useState<number | undefined>(stats);

  const handleCheckboxChange = (index: number) => {
    setCheckedIndex(index === checkedIndex ? undefined : index);
    onSelectStats && onSelectStats(index === checkedIndex ? undefined : index);
  };

  return (
    <>
      <div className="flex bg-gray-50 rounded-lg p-4 border border-gray-300 w-fit">
        <div className="w-8 sm:w-12 font-footballlog text-3xl sm:text-5xl italic text-gray-700">
          {checkedIndex || '-'}
        </div>
        <ul className="flex justify-center items-center">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((index) => (
            <li key={index} className="mx-0 sm:mx-1">
              <input
                type="checkbox"
                id={`stats${index}`}
                name="radioGroup"
                checked={index === checkedIndex}
                onChange={() => handleCheckboxChange(index)}
                className="hidden"
              />
              <label htmlFor={`stats${index}`} className="cursor-pointer inline-flex justify-center items-center">
                <div
                  className={`${
                    index <= (checkedIndex || 0) ? 'star text-sm sm:text-2xl' : 'star-gray text-sm sm:text-2xl'
                  }`}></div>
              </label>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default SelectStats;
